// HUD: stars, goal, toolbox, help (hint) and hand hint
import { Physics } from '../core/physics';
import { GFX } from '../core/graphics';
import { SFX } from '../core/audio';
import { $, ctx } from './dom';
import { G, usedOf, toScreen } from './state';
import { I, setI } from './icons';
import { Store } from '../core/store';
import { toolDown } from './input';
import { drawPart } from './render';
import { hasIntro, openIntro } from './intro';

// ---------- HUD ----------
export function updateHud() {
  const used = G.pl.length, s = used === 0 ? 3 : Physics.starsFor(G.level, used);
  const hs = $('#hudStars');
  hs.innerHTML = I.star + I.star + I.star;
  [...hs.children].forEach((el, i) => el.classList.toggle('off', i >= s));
  const gc = $('#goalChip');
  if (G.S && G.S.need > 1) {
    gc.hidden = false;
    gc.innerHTML = Array.from({ length: G.S.need }, (_, i) => `<i class="dot ${i < (G.S.inGoal || 0) ? 'on' : ''}"></i>`).join('') + `<span>${G.S.inGoal || 0}/${G.S.need}</span>`;
  } else gc.hidden = true;
  const showHint = G.level.solution.length && (Store.d.settings.hintAlways || G.fails >= 3) && G.state === 'build';
  const hb = $('#hintBtn');
  if (showHint && hb.hidden) { hb.hidden = false; hb.classList.add('pop-in'); } else if (!showHint) hb.hidden = true;
  const pb = $('#playBtn');
  const playing = G.state === 'play';
  pb.className = 'rb big ' + (playing ? 'stop' : 'go') + (G.state === 'build' && G.pl.length && !G.everPlayed ? ' pulse' : '');
  setI(pb, playing ? 'stop' : 'play');
  for (const el of document.querySelectorAll<HTMLElement>('.tool')) {
    const t = el.dataset.t!, left = G.level.tools[t] - usedOf(t);
    el.querySelector('.n')!.textContent = String(left);
    el.classList.toggle('empty', left <= 0);
  }
}

export function buildTools() {
  const box = $('#tools'); box.innerHTML = '';
  for (const t of Object.keys(G.level.tools)) {
    const b = document.createElement('div'); b.className = 'tool'; b.dataset.t = t; b.setAttribute('role', 'button'); b.setAttribute('aria-label', t);
    const c = document.createElement('canvas'); c.width = 168; c.height = 168; GFX.icon(c, t); b.appendChild(c);
    const n = document.createElement('span'); n.className = 'n'; b.appendChild(n);
    if (hasIntro(t)) { const q = document.createElement('span'); q.className = 'q'; q.textContent = '?'; b.appendChild(q);
      q.addEventListener('pointerdown', e => { e.stopPropagation(); SFX.play('click'); openIntro(t); }); }
    b.addEventListener('pointerdown', e => toolDown(e, t));
    box.appendChild(b);
  }
}

// ---------- Help (hint) ----------
$('#hintBtn').addEventListener('click', () => { SFX.play('click'); G.hintStep = Math.min(G.hintStep + 1, G.level.solution.length * 2); G.hintT = G.t; $('#hintBtn').classList.remove('pulse'); });
export function drawHint() {
  if (!G.hintStep || G.state !== 'build') return;
  const k = Math.floor((G.hintStep - 1) / 2), full = (G.hintStep - 1) % 2 === 1;
  for (let j = 0; j <= k; j++) {
    const s = G.level.solution[j]; if (!s) continue;
    const showFull = j < k || full;
    // soft, blurry glow around roughly the right spot (not exact)
    const off = ((G.li * 37 + j * 53) % 60) - 30, cx = s.x + off, cy = s.y - off * 0.6;
    const breathe = 0.75 + Math.sin(G.t * 0.05) * 0.25;
    ctx.save();
    const gr = ctx.createRadialGradient(cx, cy, 10, cx, cy, 120);
    gr.addColorStop(0, `rgba(255,214,90,${0.32 * breathe})`); gr.addColorStop(1, 'rgba(255,214,90,0)');
    ctx.fillStyle = gr; ctx.beginPath(); ctx.arc(cx, cy, 120, 0, 7); ctx.fill();
    if (showFull) { ctx.globalAlpha = 0.22; drawPart(s, false, true); }
    ctx.restore();
  }
}

// ---------- Hand that shows how to drag (level 1) ----------
let handTimer: ReturnType<typeof setTimeout> | undefined;
export function handHint() {
  hideHand();
  if (G.li !== 0) return;
  handTimer = setTimeout(() => { if (G.pl.length === 0 && G.state === 'build' && !$('#game').hidden && !G.everPlayed) $('#hand').hidden = false; }, 20000);
}
export function hideHand() { clearTimeout(handTimer); $('#hand').hidden = true; }
export function animHand() {
  const h = $('#hand'); if (h.hidden) return;
  const tool = document.querySelector('.tool'); if (!tool) return;
  const r = tool.getBoundingClientRect();
  const target = toScreen(620, 170); // only shows "drag out here", not where the part goes
  const k = (G.t % 150) / 150, e = k < 0.15 ? 0 : k > 0.75 ? 1 : (k - 0.15) / 0.6, ee = e * e * (3 - 2 * e);
  const x = r.left + r.width / 2 + (target.x - r.left - r.width / 2) * ee, y = r.top + r.height / 2 + (target.y - r.top - r.height / 2) * ee;
  h.style.left = (x - 20) + 'px'; h.style.top = (y - 6) + 'px'; h.style.opacity = k > 0.9 ? '0' : '1';
}

setI($('#hintBtn'), 'bulb'); setI($('#infoBtn'), 'q');
